<template>
  <q-linear-progress>
    <slot />
  </q-linear-progress>
</template>
